import { Button, Card, Skeleton } from 'antd';
import PropTypes from 'prop-types';
import { EditOutlined } from '@ant-design/icons';
import { pensionersExtraInfosListContent } from './listContent/pensionersExtraInfosListContent';
import { outOfNavRoutes } from '../../../../../utils/constants/ownerPensionerRoutes';
import { CardTitle } from '../../../../../components/CardTitle/CardTitle';
import { InfoGrid } from '../../../../../components/InfoGrid/InfoGrid';

export const ExtraInfos = ({
  profile,
  t,
  navigate,
  isLoading,
  checkProfileLock,
  profileLockMessage
}) => (
  <Card
    title={
      <CardTitle icon="profile">{t('pensioners.show.extra_info')}</CardTitle>
    }
    extra={
      <Button
        icon={<EditOutlined />}
        onClick={() => {
          if (checkProfileLock) {
            profileLockMessage(t, 'profile');
            return;
          }
          navigate(
            `${outOfNavRoutes.PROFILE}/edit/${profile?._id}?fieldsActiveKey=extraInfosFields`
          );
        }}
      >
        {t('buttons.edit')}
      </Button>
    }
  >
    <Skeleton loading={isLoading} active>
      <InfoGrid items={pensionersExtraInfosListContent(profile, t)} />
    </Skeleton>
  </Card>
);

ExtraInfos.propTypes = {
  profile: PropTypes.shape({
    _id: PropTypes.string
  }).isRequired,
  t: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  checkProfileLock: PropTypes.bool.isRequired,
  profileLockMessage: PropTypes.func.isRequired
};
